(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@platform/api/index"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@platform/api/index", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["@platform/base/index"] = factory(require("react"), require("@platform/api/index"), require("react-dom"));
	else
		root["@platform/base/index"] = factory(root["React"], root["@platform/api/index"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__6__) {
return 